import { useTransition } from '@react-spring/web';
import PropTypes from 'prop-types';
const Transition = ({ children, open, config, }) => {
    const transition = useTransition(open, config);
    return transition((interpolation, item) => item ? children(interpolation) : null);
};
Transition.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    open: PropTypes.bool.isRequired,
    config: PropTypes.shape({
        from: PropTypes.object,
        enter: PropTypes.object.isRequired,
        leave: PropTypes.object,
        config: PropTypes.object
    }).isRequired
};
export { Transition };
//# sourceMappingURL=Transition.js.map